(() => {
  const swatchImageSelector = [
    '#mini-cart__nosto-you-may-also-like .ns-color-swatch-img',
    '#mini-cart__nosto-recently-viewed .ns-color-swatch-img',
  ].join(', ');

  document.addEventListener('error', (event) => {
    const image = event.target;

    if (
      !(image instanceof HTMLImageElement)
      || !image.matches(swatchImageSelector)
      || !image.src.includes('formattedName')
      || image.dataset.nostoSwatchFallback
    ) {
      return;
    }

    const productLink = image.closest('.ns-product')?.querySelector('a[href*="/products/"]');
    const productPath = productLink
      ? new URL(productLink.href, window.location.origin).pathname
      : '';
    const productHandle = productPath.match(/\/products\/([^/]+)/)?.[1];

    if (!productHandle) {
      return;
    }

    image.dataset.nostoSwatchFallback = 'true';
    image.src = image.src.replace(/productcolor__[^/]+(?=\.[^.]+(?:\?|$))/, `productcolor__${productHandle}`);
  }, true);
})();
